import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'localization';

const PoliciesPlaceholder: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="org-settings-section">
      <header className="org-settings-section__header">
        <h2 className="org-settings-section__title">{t('orgSettings.policies.title')}</h2>
        <p className="org-settings-section__subtitle">{t('orgSettings.policies.description')}</p>
      </header>
      <div className="org-settings-section__empty">
        <i className="pi pi-shield" aria-hidden="true" />
        <p>{t('orgSettings.placeholder.comingSoon')}</p>
        <Link to="/marketplace">{t('orgSettings.policies.approachesLinkLabel')}</Link>
      </div>
    </div>
  );
};

export default PoliciesPlaceholder;
